<script>
	import { createEventDispatcher } from "svelte";

	import PieceC from "./Piece.svelte";

	export let x;
	export let y;
	export let cellSize;
	export let options;

	$: console.log("options:", options);

	const dispatch = createEventDispatcher();

	function handleClick(option) {
		return function () {
			dispatch("choice", { option });
		};
	}
</script>

<div
	class="root centered vstack"
	style={`--pos-x: ${x}px; --pos-y: ${y}px; --cell-size: ${cellSize}px`}
>
	{#each options as option}
		<div class="option" on:click={handleClick(option)}>
			<PieceC piece={option.promotion} />
		</div>
	{/each}
</div>

<style>
	.root {
		position: absolute;
		top: var(--pos-y);
		left: var(--pos-x);
		width: var(--cell-size);
	}

	.option {
		background-color: var(--light-color);
		cursor: pointer;
	}

	.option:hover {
		background-color: var(--dark-hover-bg-color);
	}
</style>
